import { useCallback } from "react";
import debounce from "lodash/debounce";


export default function useDebounce() {
  return useCallback(
    (func, wait, options) => {
      return debounce(func, wait, options);
    },
    []
  );
}
